import { merge } from '../../helper';

import * as exInput from '../../forms/input';
import * as exLink from '../link';
import * as exElement from '../element';

// ----------------------------------------------------------------------------

function light(config: Record<string, any> = {}): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {
        data: ['Off', 'On'],
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const elements: Record<string, any> = {};

    // Create element (label)
    const elSwitch = exElement.create({
        tag: 'label',
        class: {
            new: 'switch-' + defConfig.type,
        },
    });
    elements.element = elSwitch;

    // Create element (input)
    const input = exInput.create({
        type: 'checkbox',
    });
    elSwitch.appendChild(input.element);

    // Create element (span) (alert)
    const elSpanAlert = exElement.create({
        tag: 'span',
        class: {
            new: 'alert alert-light',
        },
    });
    elSwitch.appendChild(elSpanAlert);

    // Foreach Data
    for (const item of defConfig.data) {
        // Create element (span)
        const elSpan = exElement.create({
            tag: 'span',
            html: item,
        });
        elSpanAlert.appendChild(elSpan);
    }

    // Create element (link)
    const link = exLink.create({
        merge: defConfig.button,
        class: {
            new: 'btn btn-primary',
        },
    });
    elSpanAlert.appendChild(link.element);

    // Return
    return elements;
}

// ----------------------------------------------------------------------------

export { light };
